import React from "react";
import { PaginatedApiLogType } from "../../../../../../../../libs/Utils/Types/APIManagement";
import { TableColumnsType } from "antd";
import ReusableTable from "../../../../../../../../global components/Table/Table";
import dayjs from "dayjs";
import s from "./RequestTable.module.scss";
import clsx from "clsx";
type ColumnType = {
  key: string;
  requestId: string;
  createdAt: string; // ISO date string
  keyPreview: string;
  endpoint: string;
  statusCode: number;
};
type PropType = {
  data: PaginatedApiLogType["data"];
  loading: boolean;
};
function RequestTable({ data, loading }: PropType) {
  const columns: TableColumnsType<ColumnType> = [
    {
      title: "Request ID",
      dataIndex: "requestId",
      key: "requestId",
      render: (requestId: string) => <span>{requestId}</span>,
    },
    {
      title: "Timestamp",
      dataIndex: "createdAt",
      key: "createdAt",
      render: (createdAt: string) => <span>{createdAt}</span>,
    },
    {
      title: "API Key",
      dataIndex: "keyPreview",
      key: "keyPreview",
      render: (keyPreview: string) => <span>{keyPreview}</span>,
    },
    {
      title: "Endpoint",
      dataIndex: "endpoint",
      key: "endpoint",
      render: (endpoint: string) => <span>{endpoint}</span>,
    },
    {
      title: "Status",
      dataIndex: "statusCode",
      key: "statusCode",
      render: (statusCode: number) => (
        <span
          className={clsx({
            [s.active]: statusCode === 200,
            [s.revoked]: statusCode === 500,
            [s.inactive]: statusCode !== 500 && statusCode !== 200,
          })}
        >
          {statusCode}
        </span>
      ),
    },
  ];
  const dataSource: ColumnType[] = data.map((item) => ({
    createdAt: dayjs.utc(item.createdAt).local().format("YYYY-MM-DD hh:mm:ss"),
    endpoint: item.endpoint,
    requestId: item.requestId,
    key: item.apiKeyId,
    keyPreview: item.keyPreview,
    statusCode: item.statusCode,
  }));
  return (
    <ReusableTable
      columns={columns}
      dataSource={dataSource}
      loading={loading}
    />
  );
}

export default RequestTable;
